<div class="flex min-w-0 flex-col gap-2">
  <div
    #origin
    class="relative flex !h-9 min-w-0 items-center rounded-md border bg-white text-sm leading-5 transition"
    [ngClass]="
      draft && draft.controls.name.invalid && draft.controls.name.touched
        ? 'border-red-400'
        : 'border-gray-200 focus-within:border-blue-400'
    "
  >
    <span class="flex !h-full w-9 shrink-0 items-center justify-center border-r border-gray-100 text-gray-400">
      <app-icon class="!h-5 !w-5 !text-[20px] !leading-5">apartment</app-icon>
    </span>

    @if (draft) {
      <input
        class="!h-full min-w-0 flex-1 !border-0 bg-transparent !px-2 !py-0 !text-sm !leading-5 text-gray-800 outline-none placeholder:text-gray-400"
        [formControl]="draft.controls.name"
        [placeholder]="'board_v3_company_name' | translate"
        maxlength="255"
      />
      @if (isEditing) {
        <span
          class="pointer-events-none absolute -top-2 right-16 rounded-full border border-blue-200 bg-blue-50 px-1.5 text-[10px] font-semibold uppercase leading-4 tracking-wide text-blue-600"
        >
          {{ 'board_v3_contact_edit_badge' | translate }}
        </span>
      } @else {
        <span
          class="pointer-events-none absolute -top-2 right-8 rounded-full border border-emerald-200 bg-emerald-50 px-1.5 text-[10px] font-semibold uppercase leading-4 tracking-wide text-emerald-600"
        >
          {{ 'board_v3_company_new_badge' | translate }}
        </span>
      }
    } @else if (slot.existing; as company) {
      <span class="min-w-0 flex-1 truncate px-2 text-sm text-gray-800" [title]="getCompanyName(company)">
        {{ getCompanyName(company) }}
      </span>
    } @else {
      <input
        #searchInput
        type="text"
        class="!h-full min-w-0 flex-1 !border-0 bg-transparent !px-2 !py-0 !text-sm !leading-5 text-gray-800 outline-none placeholder:text-gray-400"
        autocomplete="off"
        [ngModel]="query"
        (ngModelChange)="onQueryChange($event)"
        (focus)="onFocus()"
        (keydown.escape)="open = false"
        (keydown.enter)="$event.preventDefault(); !searching && !results.length && query.trim() && createNew()"
        [placeholder]="'board_v3_company_picker_placeholder' | translate"
      />
    }

    @if (slot.existing && !draft) {
      <button
        type="button"
        class="grid !h-full w-8 shrink-0 place-items-center text-gray-400 hover:text-gray-600"
        [matTooltip]="'board_v3_company_edit' | translate"
        (click)="edit()"
      >
        <app-icon class="!h-[18px] !w-[18px] !text-[18px] !leading-none">edit</app-icon>
      </button>
    }
    @if (isEditing) {
      <button
        type="button"
        class="grid !h-full w-8 shrink-0 place-items-center text-gray-400 hover:text-gray-600"
        [matTooltip]="'board_v3_contact_edit_cancel' | translate"
        (click)="cancelEdit()"
      >
        <app-icon class="!h-[18px] !w-[18px] !text-[18px] !leading-none">undo</app-icon>
      </button>
    }
    @if (slot.existing || draft) {
      <button
        type="button"
        class="grid !h-full w-8 shrink-0 place-items-center text-gray-400 hover:text-gray-600"
        [matTooltip]="'board_v3_company_change' | translate"
        (click)="change()"
      >
        <app-icon class="!h-[18px] !w-[18px] !text-[18px] !leading-none">swap_horiz</app-icon>
      </button>
    } @else {
      <span class="grid !h-full w-8 shrink-0 place-items-center text-gray-400">
        <app-icon class="!h-[18px] !w-[18px] !text-[18px] !leading-none">search</app-icon>
      </span>
    }
  </div>

  @if (draft) {
    <div class="flex min-w-0 flex-col gap-2 pl-4">
      <div class="flex flex-col gap-1">
        <span class="text-xs text-gray-400">{{ 'phones' | translate }}</span>
        @for (control of draft.controls.phones.controls; track control; let i = $index) {
          <ng-container
            [ngTemplateOutlet]="listRow"
            [ngTemplateOutletContext]="{ list: draft.controls.phones, control, index: i, placeholder: '+380...' }"
          />
        }
        <button
          type="button"
          class="flex items-center gap-1 self-start text-xs text-blue-500 hover:text-blue-600"
          (click)="addPhone()"
        >
          <app-icon class="!text-[14px] !h-[14px] !w-[14px] !leading-none">add</app-icon>
          {{ 'add_phone' | translate }}
        </button>
      </div>
      <div class="flex flex-col gap-1">
        <span class="text-xs text-gray-400">{{ 'emails' | translate }}</span>
        @for (control of draft.controls.emails.controls; track control; let i = $index) {
          <ng-container
            [ngTemplateOutlet]="listRow"
            [ngTemplateOutletContext]="{ list: draft.controls.emails, control, index: i, placeholder: 'email@example.com' }"
          />
        }
        <button
          type="button"
          class="flex items-center gap-1 self-start text-xs text-blue-500 hover:text-blue-600"
          (click)="addEmail()"
        >
          <app-icon class="!text-[14px] !h-[14px] !w-[14px] !leading-none">add</app-icon>
          {{ 'add_email' | translate }}
        </button>
      </div>
      <div class="flex flex-col gap-1">
        <span class="text-xs text-gray-400">{{ 'addresses' | translate }}</span>
        <app-board-v3-address-editor [formControl]="draft.controls.addresses" size="small" />
      </div>
    </div>
  }
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="open && !slot.existing && !draft"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayWidth]="overlayWidth"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayViewportMargin]="8"
  (overlayOutsideClick)="onOutsideClick($event)"
  (detach)="open = false"
>
  <div class="crm-scroll max-h-72 overflow-y-auto rounded-lg border border-slate-200 bg-white py-1 shadow-lg">
    @if (searching && !results.length) {
      <div class="flex h-12 items-center justify-center">
        <app-loader type="indeterminate" />
      </div>
    } @else {
      @for (company of results; track company.id) {
        <button
          type="button"
          class="flex w-full min-w-0 items-center gap-2 px-3 py-2 text-left transition hover:bg-slate-50"
          (mousedown)="$event.preventDefault()"
          (click)="select(company)"
        >
          <span class="grid h-7 w-7 shrink-0 place-items-center rounded-md bg-slate-100 text-slate-500">
            <app-icon class="!h-4 !w-4 !text-[16px] !leading-none">apartment</app-icon>
          </span>
          <span class="min-w-0 flex-1">
            <span class="block truncate text-sm font-medium text-gray-900">{{ getCompanyName(company) }}</span>
            @if (getCompanySummary(company); as summary) {
              <span class="block truncate text-xs text-gray-500">{{ summary }}</span>
            }
          </span>
        </button>
      } @empty {
        <div class="truncate px-3 py-2 text-sm text-gray-800">«{{ query.trim() }}»</div>
      }
    }

    <button
      type="button"
      class="flex w-full items-center gap-2 border-t border-slate-100 px-3 py-2 text-left !text-sm font-medium text-orange-600 transition hover:bg-orange-50"
      (mousedown)="$event.preventDefault()"
      (click)="createNew()"
    >
      <span class="grid h-6 w-6 shrink-0 place-items-center rounded-full bg-orange-50 text-orange-600">
        <app-icon class="!h-4 !w-4 !text-[16px] !leading-none">add</app-icon>
      </span>
      {{ 'board_v3_company_create_new_lower' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #listRow let-list="list" let-control="control" let-index="index" let-placeholder="placeholder">
  <div class="flex min-w-0 items-center gap-1.5">
    <app-input
      class="block min-w-0 flex-1 [&_.p-inputtext]:!h-9 [&_.p-inputtext]:!px-3 [&_.p-inputtext]:!text-sm"
      [formControl]="control"
      size="small"
      [placeholder]="placeholder"
    />
    @if (list.length > 1 || control.value) {
      <button
        type="button"
        class="grid h-6 w-6 shrink-0 place-items-center rounded text-gray-400 hover:bg-gray-100 hover:text-red-400"
        [attr.aria-label]="'delete' | translate"
        (click)="removeRow(list, index)"
      >
        <app-icon class="!h-4 !w-4 !text-[16px] !leading-none">close</app-icon>
      </button>
    }
  </div>
</ng-template>
